import React from "react";
import TicketsTableRow from "./TicketsTableRow";

const TicketsTableBody = ({
  data,
  headers,
  rowKey,
  dropdownIndex,
  toggleDropdown,
  onActionClick,
  onRowClick,
  rowClassName,
  tableStyle,
}) => {
  if (data.length === 0) {
    return (
      <tbody>
        <tr>
          <td colSpan={headers.length + 1} className="text-center py-4">
            No tickets available
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      {data.map((row, idx) => (
        <TicketsTableRow
          key={row[rowKey]}
          row={row}
          headers={headers}
          rowKey={rowKey}
          isDropdownOpen={dropdownIndex === idx}
          toggleDropdown={toggleDropdown}
          onActionClick={onActionClick}
          onRowClick={onRowClick}
          rowIndex={idx}
          rowClassName={rowClassName}
          tableStyle={tableStyle}
        />
      ))}
    </tbody>
  );
};

export default TicketsTableBody;
